/* THE LIBRARY — email join, NATIVE (RFC-EMAIL-001 C7). Replaces the direct-to-Klaviyo path.
   POSTs to OUR email-signup endpoint (same as cnc-popup.js) so a Library signup lands in our consent
   ledger and enrols the native welcome flow — routed by the SERIES of the page the reader is on
   (auto, no poll: a Library page IS a series):
     source: "library"       → attribution (distinct from the popup's "cnc_popup")
     fandom:  <page series>   → world-routed welcome (unmatched series fall back to the trope welcome)
     country: <localization>  → regime resolved at capture so the profile is sendable
   No page reload; success/error render inline. Wires every [data-libcard-form] on the page (inline + popup). */
(function () {
  var body = document.body;
  var ENDPOINT = body.getAttribute('data-cnc-endpoint') ||
                 'https://dkzndqkjjzhmmcebqoib.supabase.co/functions/v1/email-signup';
  var COUNTRY  = (body.getAttribute('data-country') || 'US').toUpperCase();
  var DONE_KEY = 'cnc-lib-join-ack';   // shared with the popup so it never re-nags a subscriber

  function series() { return body.getAttribute('data-lib-series') || ''; }

  function subscribe(email, tag) {
    var s = series();
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        country: COUNTRY,
        fandom: s || null,
        source: 'library',
        form_url: location.href,
        consent_text: 'Subscribed to Caffeine & Curses via the Library (' + (tag || 'library') + ')'
      })
    });
  }

  function wire(form) {
    if (form.__libJoinWired) return;
    form.__libJoinWired = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var wrap  = form.closest('[data-libcard]') || form.parentNode;
      var input = form.querySelector('input[type=email]');
      var btn   = form.querySelector('button[type=submit]');
      var ok    = wrap.querySelector('.libcard__ok');
      var err   = wrap.querySelector('.libcard__err');
      var email = ((input && input.value) || '').trim();
      if (!email || email.indexOf('@') < 1) {
        if (err) { err.textContent = 'Enter a valid email.'; err.hidden = false; }
        return;
      }
      if (btn) btn.disabled = true;
      if (err) err.hidden = true;
      subscribe(email, form.getAttribute('data-libcard-tag')).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok && d && d.subscribed) {
            try { localStorage.setItem(DONE_KEY, '1'); } catch (e2) {}
            form.hidden = true;
            if (ok) ok.hidden = false;
            var note = wrap.querySelector('.libcard__note'); if (note) note.hidden = true;
          } else {
            if (btn) btn.disabled = false;
            if (err) { err.textContent = "Couldn't sign you up — try again in a moment."; err.hidden = false; }
          }
        });
      }).catch(function () {
        if (btn) btn.disabled = false;
        if (err) { err.textContent = "Couldn't sign you up — try again in a moment."; err.hidden = false; }
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-libcard-form]');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
